import axios from "../utiles/axios.util";

export async function get(url, config = {}) {
    try {
        let response;

        response = await axios.get(url, config);

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data;
            } else {
                return null;
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        if (e.response) {
            console.log("status:", e.response.status);
            console.log("data:", e.response.data);
        } else {
            console.log("error:", e.message);
        }
    }

    return axios.get(url);
}

export async function post(url, formData) {
    try {
        let response;

        response = await axios.post(url, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.status === 200) {
            if (response.data.code === 200) {
                return response.data;
            } else {
                alert(response.data.msg);
                return null;
            }
        } else {
            alert(
                "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
            );
        }
    } catch (e) {
        if (e.response) {
            console.log("status:", e.response.status);
            console.log("data:", e.response.data);
        } else {
            console.log("error:", e.message);
        }
    }
}

export async function postJson(url, data) {
    try {
        let response = await axios.post(url, data, {
            headers: { "Content-Type": "application/json" },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            alert("네트워크 장애가 발생하였습니다.");
        }
    } catch (e) {
        console.error("JSON Post Error:", e);
    }
}
